import { Toggle, VText } from '@vake/ui-kit';
import { FC, useState } from 'react';
import { useDownloadOverwatchReport } from '../../../../requests/reports';
import { useOverwatchContext } from '../../interactiveReport/overwatch-2-context';
import { DownloadView } from './download';

export const Settings: FC = () => {
    const {
        report: { uuid },
        filters: { startDate },
        settings: {
            showEEZ,
            showProcessingStatus,
            showSatelliteImage,
            setShowEEZ,
            setShowProcessingStatus,
            setShowSatelliteImage,
        },
        view: { selectedView },
    } = useOverwatchContext();
    const [downloadFullDataset, setDownloadFullDataset] = useState<boolean>(false);
    const {
        isLoading: isLoadingDownload,
        isError: isErrorDownload,
        isSuccess: isSuccessDownload,
        error: errorDownload,
    } = useDownloadOverwatchReport(uuid, startDate || new Date(), downloadFullDataset);
    return (
        <>
            <div className="p-4">
                <VText variant="H4">Satellite Images</VText>
                <div className="flex items-center justify-between py-1">
                    <VText variant="B2">Show Satellite Image</VText>
                    <Toggle
                        isOn={showSatelliteImage}
                        onChange={setShowSatelliteImage}
                        offIcon={undefined}
                        onIcon={undefined}
                        size="small"
                        onBackgroundColor="success-background"
                    />
                </div>
                <div className="flex items-center justify-between py-1">
                    <VText variant="B2">Show Processing Statuses</VText>
                    <Toggle
                        isOn={showProcessingStatus}
                        onChange={setShowProcessingStatus}
                        offIcon={undefined}
                        onIcon={undefined}
                        size="small"
                        onBackgroundColor="success-background"
                    />
                </div>
            </div>
            <div className="p-4">
                <VText variant="H4">Background Layers</VText>
                <div className="flex items-center justify-between py-1">
                    <VText variant="B2">Show Economic Zones</VText>
                    <Toggle
                        isOn={showEEZ}
                        onChange={setShowEEZ}
                        offIcon={undefined}
                        onIcon={undefined}
                        size="small"
                        onBackgroundColor="success-background"
                    />
                </div>
            </div>
            <div className="p-4">
                <VText variant="H4">Download options</VText>
                {selectedView === 'map' && (
                    <DownloadView
                        downloadFullDataset={downloadFullDataset}
                        setDownloadFullDataset={setDownloadFullDataset}
                        isLoadingDownload={isLoadingDownload}
                        isSuccessDownload={isSuccessDownload}
                        isErrorDownload={isErrorDownload}
                        errorMessageDownload={errorDownload instanceof Error ? errorDownload.message : 'Unknown error'}
                    />
                )}
                {selectedView === 'table' && <VText variant="B2">Not available in table view at the moment</VText>}
            </div>
        </>
    );
};
